import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";


class EmailVerificationView extends React.Component {

    static propTypes = {
        email: PropTypes.string.isRequired,
        isCheckingCode: PropTypes.bool.isRequired,
        isRequestingEmail: PropTypes.bool.isRequired,
        validationCode: PropTypes.object.isRequired
    };

    handleValidationCodeChanged = (event) => {
        console.log(event.target.value);
        EventPublisher.publish(
            UIInteractionEvents.EMAIL_VERIFICATION_CODE_CHANGED,
            {
                validationCode: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleEmailSendRequest = (event) => {
        EventPublisher.publish(UIInteractionEvents.EMAIL_VERIFICATION_EMAIL_REQUESTED, {});
    };

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.validationCode.isValid) {
            EventPublisher.publish(
                UIInteractionEvents.EMAIL_VERIFICATION_CHECK_SUBMITTED,
                {
                    validationCode: this.props.validationCode.currentValue
                }
            );
        }
    };

    generateClassNameWithValidityForFormFieldWithValidState(defaultClassName, formFieldWithValidityState) {
        if (formFieldWithValidityState.isTouched && formFieldWithValidityState.isValid) {
            return defaultClassName+" is-valid";
        } else if (formFieldWithValidityState.isTouched && !formFieldWithValidityState.isValid) {
            return defaultClassName+" is-invalid";
        }
        return defaultClassName;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Please Verify Your Email Address
                            </div>
                            <div className="card-body">
                                A verification email has been sent to the address: <strong>{this.props.email}</strong>. It
                                contains a 5 digit code which can be used to unlock your account.  This verifies that
                                the email address is valid and that you have access to it.

                                <form noValidate>
                                    <div className="form-group">
                                        <label htmlFor="inputValidationCode">Validation Code</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.validationCode)}>
                                            <input
                                                type="number"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.validationCode)}
                                                id="inputValidationCode"
                                                placeholder="12345"
                                                onChange={this.handleValidationCodeChanged}
                                                required={true}
                                                min={10000}
                                                max={99999}
                                                disabled={this.props.isCheckingCode}
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    type="button"
                                                    id="resendButton"
                                                    onClick={this.handleEmailSendRequest}
                                                    disabled={this.props.isRequestingEmail}
                                                >
                                                    {
                                                        this.props.isRequestingEmail ?
                                                            <span>
                                                                <span className="spinner-border spinner-border-sm mr-2"/>
                                                                Sending...
                                                            </span>
                                                            :
                                                            "Resend Email"
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                        <small id="displayNameHelpBlock" className="form-text text-muted">
                                            Copy the 5 digits from your email.
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            Please enter the 5 digit code from your email.
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className={this.props.validationCode.isValid ? "btn btn-primary" : "btn btn-danger"}
                                        onClick={this.handleFormSubmit}
                                        disabled={this.props.isSaving || !this.props.validationCode.isValid}
                                    >
                                        {
                                            this.props.isSaving ?
                                                (
                                                    <span>
                                                        <span className="spinner-border spinner-border-sm mr-2"/>
                                                        Checking
                                                    </span>
                                                ) :
                                                "Submit"
                                        }
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default EmailVerificationView;